import React from 'react';
import { Link } from 'react-router-dom';
import { useT } from '@repo/common';
import { ReactComponent as TargetIcon } from '@repo/common/assets/icons/24px/icon_24px_target-arrow_outline.svg';
import { ReactComponent as PlusIcon } from '@repo/common/assets/icons/20px/icon_20px_plus_outline.svg';

// Aurora gradient ported from remix-korean CreatorProposal's PAYOUT section.
const AURORA_STYLES = `
  .job-banner-aurora-glow {
    position: absolute;
    inset: 0;
    border-radius: 30px;
    background: linear-gradient(180deg, #a8f2d9, #4dd5a3);
    filter: blur(18px);
    opacity: .55;
    animation: jobBannerAuroraGlow 8s linear infinite;
    pointer-events: none;
  }
  @keyframes jobBannerAuroraGlow {
    to { filter: blur(18px) hue-rotate(360deg); }
  }
  .job-banner-aurora-ring {
    position: absolute;
    inset: 0;
    border-radius: 30px;
    padding: 2px;
    background: conic-gradient(from 180deg, #4dd5a3, #a8f2d9, #8fc2ff, #d9a6f5, #4dd5a3);
    -webkit-mask: linear-gradient(#fff 0 0) content-box, linear-gradient(#fff 0 0);
    -webkit-mask-composite: xor;
    mask: linear-gradient(#fff 0 0) content-box exclude, linear-gradient(#fff 0 0);
    animation: jobBannerAuroraRing 8s linear infinite;
    pointer-events: none;
  }
  @keyframes jobBannerAuroraRing {
    to { filter: hue-rotate(360deg); }
  }
`;

export default function CreateJobBanner({ variant = 'aurora' }) {
  const t = useT();

  // 'plain': 모바일 공고 관리 화면 시안 — 오로라 없이 테두리 카드
  if (variant === 'plain') {
    return (
      <Link
        to='/jobs/admin/new'
        className='flex h-20 w-full items-center gap-2 rounded-[20px] border border-grayscale-gray02 bg-grayscale-gray00 px-6 py-[18px] text-text-primary focus-visible:outline-green-deep03'
      >
        <TargetIcon className='shrink-0' />
        <span className='min-w-0 flex-1 typo-b14Strong'>{t('Post a job, find your next hire', '공고를 등록하고 새로운 인재를 만나보세요')}</span>
        <span className='flex shrink-0 items-center justify-center p-[2px]'>
          <PlusIcon />
        </span>
      </Link>
    );
  }

  return (
    <div className='relative w-full'>
      <style>{AURORA_STYLES}</style>
      <div aria-hidden className='job-banner-aurora-glow' />
      <Link
        to='/jobs/admin/new'
        className='relative flex min-h-[80px] w-full items-center gap-2 rounded-[30px] bg-white p-6 text-text-primary focus-visible:outline-green-deep03'
      >
        <span aria-hidden className='job-banner-aurora-ring' />
        <TargetIcon className='shrink-0' />
        <span className='flex-1  typo-b14Strong   tabletH:typo-b20Strong'>{t('Post a job, find your next hire', '공고를 등록하고 새로운 인재를 만나보세요')}</span>
        <PlusIcon className='shrink-0' />
      </Link>
    </div>
  );
}
